import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../../../components/partials/PageTitle";

import { BiArrowBack } from "react-icons/bi";
import { RiArrowDropDownLine } from "react-icons/ri";
import { BeatLoader } from "react-spinners";
import RiskInformation from "../../../components/customer/policy application/RiskInformation";
import Transactions from "../../../components/customer/policy application/Transactions";
import ModalContainer from "../../../components/modals/ModalContainer";
import ConfirmUnderwrite from "../../../components/modals/policy/ConfirmUnderwrite";
import Confirmation from "../../../components/modals/policy/Confirmation";
import PayPremium from "../../../components/modals/policy/PayPremium";
import PreviewPolicyAppSchedule from "../../../components/modals/preview/PreviewPolicyAppSchedule";
import PaymentSchedule from "../../../components/policy/PaymentSchedule";
import { getAllCovers } from "../../../redux/slice/cover/coverSlice";
import {
  getSinglePolicyCover,
  getSinglePolicyDetails,
  resetPolicyStatus,
  resetRiskCover,
  resetSinglePolicyHistory,
} from "../../../redux/slice/policy/policySlice";
import {
  getPolicyDocument,
  resetUnderwriting,
  resetUnderwritingStatus,
} from "../../../redux/slice/underwriting/underwritingSlice";
import PolicyHistory from "../policy/policy-history/PolicyHistory";
import ReviewInformation from "./../../../components/customer/policy application/ReviewInformation";

const CustomerPolicyView = () => {
  const { customer_policy_details, isLoading, isPolicyEdited, isSuccess } =
    useSelector((state) => state.policy);
  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const [underwrite, setUnderwrite] = useState();
  const [premiumPayment, setPremiumPayment] = useState();
  const [dropdownShow, setDropdownShow] = useState(false);
  const [hasInitiateClaim, setHasInitiateClaim] = useState(null);
  // const hidePaymentBtn =
  //   customer_policy_details?.customer_transactions?.data?.some(
  //     (obj) => obj.complete_payment === "1"
  //   );

  const { state } = useLocation();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const confirmRenewal = useRef(null);
  const confirmRenewalPromptRef = useRef(null);

  const breadcrumb = {
    from: {
      title: "Applied policies",
      link: "/admin/applied-policies",
    },
    current: {
      title: "customer policy view",
      link: null,
    },
  };

  //   local state declarations
  const [tab, setTab] = useState("details");

  const dispatch = useDispatch();

  const handleRenewal = () => {
    if (customer_policy_details?.reminder[0] === false) {
      confirmRenewalPromptRef?.current?.click();
      navigate("/admin/policy-application/renewal", {
        state,
      });
    } else {
      confirmRenewal?.current.click();
    }
  };

  const temp_policy_attach_data = {
    effective_date: customer_policy_details?.policy_app_details?.effectiveDate,
    end_date: customer_policy_details?.policy_app_details?.endDate,
    repayment_frequency:
      customer_policy_details?.policy_app_details?.repayment_frequency,
    but_charge: customer_policy_details?.policy_app_details?.butCharge,
    total_annual_premium: parseInt(
      customer_policy_details?.policy_app_details?.totalPremium
    ),
    policy_id: state?.policy_id,
    customer_id: customer_policy_details?.policy_app_details?.customerId,
  };

  useEffect(() => {
    // if (isPolicyEdited) {dispatch(resetPolicyStatus())};
    if (state?.customerId) {
      dispatch(
        getSinglePolicyDetails({
          customer_id: state?.customerId,
          policy_number: state?.policyAppNumber,
        })
      );
      dispatch(
        getPolicyDocument({
          customer_id: state?.customerId,
          policy_application_number: state?.policyAppNumber,
        })
      );
      dispatch(getAllCovers(1));
    }

    if (state?.policy_id) {
      dispatch(getAllCovers(1));
      dispatch(getSinglePolicyCover(state?.policy_id));
    }
    dispatch(resetUnderwritingStatus());
    dispatch(resetUnderwriting());
    dispatch(resetRiskCover());
    dispatch(resetSinglePolicyHistory());
  }, []);

  // useEffect(() => {
  //   dispatch(
  //     getPolicyScheduleDoc({
  //       customer_id: state?.customerId,
  //       policy_application_number: state?.policyAppNumber,
  //     })
  //   );
  // }, [dispatch, state?.customerId, state?.policyAppNumber])

  useEffect(() => {
    if (isSuccess) {
      dispatch(resetPolicyStatus());
    }
  }, [isSuccess]);

  useEffect(() => {
    setUnderwrite(
      user_permissions?.some((permission) => permission.name === "underwrite")
    );

    setPremiumPayment(
      user_permissions?.some(
        (permission) => permission.name === "premium payment"
      )
    );

    setHasInitiateClaim(
      user_permissions?.some(
        (permission) => permission.name === "initiate claim"
      )
    );
  }, [user_permissions]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdown = document.querySelector(".more_actions_drowdown");
      if (
        dropdown &&
        !dropdown.contains(event.target) &&
        !dropdownRef.current.contains(event.target)
      )
        setDropdownShow(false);
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  if (!customer_policy_details) {
    return (
      <div className='mt-2'>
        <BeatLoader
          height='80'
          width='80'
          radius='9'
          color='#2e3192'
          ariaLabel='three-dots-loading'
          wrapperStyle={{}}
          wrapperClassName=''
          visible={true}
        />
      </div>
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title='Customer Policy View' breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className='row'>
        <div className='col-md-12'>
          <div className='card '>
            <div className='card-body'>
              <div className='d-flex justify-content-end mb-2'>
                <Link
                  className='btn btn-sm btn-primary d-flex align-items-center'
                  to='/admin/all-applied-general-policies'
                >
                  <BiArrowBack />
                  <span>Back</span>
                </Link>
              </div>
              <div className='border border-1 rounded-1 p-2'>
                <div className='row'>
                  <div className='col-md-10'>
                    <div className='row'>
                      <div className='col-md-6'>
                        <div className='d-flex align-items-center gap-2'>
                          <h5>Customer Name: </h5>
                          <Link
                            to={`/admin/customer-profile/${customer_policy_details?.policy_app_details?.customer_uuid}`}
                          >
                            {customer_policy_details?.policy_app_details
                              ?.customerFirstName +
                              " " +
                              customer_policy_details?.policy_app_details
                                ?.customerLastName}
                          </Link>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='d-flex align-items-center gap-2'>
                          <h5>Marketer/Agent:</h5>
                          <span>
                            {customer_policy_details?.policy_app_details
                              ?.agentFirstName +
                              " " +
                              customer_policy_details?.policy_app_details
                                ?.agentLastName}
                          </span>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='d-flex align-items-center gap-2'>
                          <h5>Customer ID:</h5>
                          <span>
                            {
                              customer_policy_details?.policy_app_details
                                ?.customerId
                            }
                          </span>
                        </div>
                      </div>
                      {/* <div className='col-md-6'>
                            <div className='d-flex align-items-center gap-2'>
                            <h5>Marketer/Agent:</h5>
                            <span>Friday Francis</span>
                            </div>
                        </div> */}
                    </div>
                  </div>
                </div>
                <div className='d-flex my-1'>
                  {/* {parseFloat(customer_policy_details?.policy_app_details?.totalPremium) ===
    // parseFloat(customer_policy_details?.payment_amount)} */}
                  {customer_policy_details?.policy_app_details?.status ===
                  "1" ? (
                    <div>
                      {underwrite && (
                        <Link
                          to={"/admin/customer-policy-view/underwrite"}
                          // className='btn btn-sm btn-primary me-2 mt-1 text-white col-md-2 col-sm-3'
                        >
                          <span className='btn btn-sm btn-primary me-2 mt-1 text-white col-md- col-sm-'>
                            Under-write
                          </span>
                        </Link>
                      )}
                    </div>
                  ) : (
                    <div className='d-flex me-2'>
                      {premiumPayment &&
                        parseFloat(
                          customer_policy_details?.policy_app_details
                            ?.totalPremium
                        ) !==
                          parseFloat(customer_policy_details?.payment_amount) &&
                        parseFloat(
                          customer_policy_details?.policy_app_details
                            ?.totalPremium
                        ) >=
                          parseFloat(
                            customer_policy_details?.payment_amount
                          ) && (
                          <div
                            className='btn btn-sm btn-primary me-2 mt-1 '
                            data-bs-toggle='modal'
                            data-bs-target='#pay_premium'
                          >
                            Pay Premium
                          </div>
                        )}
                      <div className='position-relative'>
                        <div
                          className='btn btn-sm btn-primary me- mt-1'
                          onClick={() => setDropdownShow(!dropdownShow)}
                          ref={dropdownRef}
                        >
                          <span>More Actions</span>
                          <span>
                            <RiArrowDropDownLine size={20} />
                          </span>
                        </div>
                        <div
                          className={`position-absolute shadow-lg rounded-2 p- more_actions_drowdown ${
                            dropdownShow ? "show" : ""
                          }`}
                        >
                          <ul className='w-100'>
                            <li
                              onClick={() => {
                                setDropdownShow(!dropdownShow);
                                navigate(
                                  "/admin/customer-policy-view/policy-schedule"
                                );
                              }}
                            >
                              View Policy Document
                            </li>
                            <li
                              onClick={() => {
                                setDropdownShow(!dropdownShow);
                              }}
                              data-bs-toggle='modal'
                              data-bs-target='#policy_schedule'
                            >
                              View Payment Schedule
                            </li>
                            {customer_policy_details?.policy_app_details
                              ?.proposal_document ? (
                              <li
                                onClick={() => setDropdownShow(!dropdownShow)}
                              >
                                <a
                                  href={
                                    customer_policy_details?.policy_app_details
                                      ?.proposal_document
                                  }
                                  target='_blank'
                                  className='text-grey'
                                >
                                  View Proposal Document
                                </a>
                              </li>
                            ) : null}
                            {hasInitiateClaim && <li onClick={() => setDropdownShow(!dropdownShow)}>
                              <Link
                                to={"/admin/claims"}
                                state={
                                  customer_policy_details?.policy_app_details
                                    ?.policyAppNumber
                                }
                                className='text-grey'
                              >
                                Initiate Claim
                              </Link>
                            </li>}
                            <li onClick={() => setDropdownShow(!dropdownShow)}>
                              Debit Note
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                  {customer_policy_details?.policy_app_details?.status ===
                    "3" && (
                    <div
                      className='btn btn-sm btn-primary me-2 mt-1'
                      ref={confirmRenewalPromptRef}
                      data-bs-toggle='modal'
                      data-bs-target='#confirm_renewal'
                    >
                      <span>Renew Policy</span>
                    </div>
                  )}
                </div>
                {customer_policy_details ? (
                  <div className='row my-3'>
                    <div>
                      <ul className='nav nav-pills bg-nav-pills nav-justified mb-3'>
                        <li className='nav-item cursor-p'>
                          <span
                            onClick={() => setTab("details")}
                            aria-expanded='false'
                            className={`nav-link rounded-0 p-tab-y-1 ${
                              tab === "details" && "active"
                            } border`}
                          >
                            <i className='mdi mdi-home-variant d-md-none d-block'></i>
                            <span className='d-none d-md-block'>Details</span>
                          </span>
                        </li>
                        <li className='nav-item cursor-p'>
                          <span
                            // data-bs-toggle='tab'
                            onClick={() => setTab("risk_covered")}
                            aria-expanded='true'
                            className={`nav-link rounded-0 ${
                              tab === "risk_covered" && "active"
                            } border`}
                          >
                            <i className='mdi mdi-account-circle d-md-none d-block'></i>
                            <span className='d-none d-md-block'>
                              Risk Covered
                            </span>
                          </span>
                        </li>
                        <li className='nav-item cursor-p'>
                          <span
                            // data-bs-toggle='tab'
                            onClick={() => setTab("schedule")}
                            aria-expanded='true'
                            className={`nav-link rounded-0 ${
                              tab === "schedule" && "active"
                            } border`}
                          >
                            <i className='mdi mdi-account-circle d-md-none d-block'></i>
                            <span className='d-none d-md-block'>
                              Payment Schedule
                            </span>
                          </span>
                        </li>
                        <li className='nav-item cursor-p'>
                          <span
                            // data-bs-toggle='tab'
                            onClick={() => setTab("transaction")}
                            aria-expanded='true'
                            className={`nav-link rounded-0 ${
                              tab === "transaction" && "active"
                            } border`}
                          >
                            <i className='mdi mdi-account-circle d-md-none d-block'></i>
                            <span className='d-none d-md-block'>
                              Transactions
                            </span>
                          </span>
                        </li>
                        {customer_policy_details?.get_policy_cycle?.length >
                          0 && (
                          <li className='nav-item cursor-p'>
                            <span
                              // data-bs-toggle='tab'
                              onClick={() => setTab("policy_history")}
                              aria-expanded='true'
                              className={`nav-link rounded-0 ${
                                tab === "policy_history" && "active"
                              } border`}
                            >
                              <i className='mdi mdi-account-circle d-md-none d-block'></i>
                              <span className='d-none d-md-block'>
                                Policy History
                              </span>
                            </span>
                          </li>
                        )}
                      </ul>

                      {tab === "details" && (
                        <div className='details active' id='details'>
                          <ReviewInformation
                            details={
                              customer_policy_details?.policy_app_details
                            }
                            payment_amount={
                              customer_policy_details?.payment_amount
                            }
                          />
                        </div>
                      )}
                      {tab === "risk_covered" && (
                        <div className='active' id='risk_covered'>
                          <RiskInformation
                            details={customer_policy_details?.policy_app_rsk}
                          />
                        </div>
                      )}
                      {tab === "schedule" && (
                        <div className='active' id='schedule'>
                          <PaymentSchedule />
                        </div>
                      )}
                      {tab === "transaction" && (
                        <div className='active' id='transaction'>
                          <Transactions
                            customerTransactions={
                              customer_policy_details?.customer_transactions
                            }
                            view
                          />
                        </div>
                      )}
                      {customer_policy_details?.get_policy_cycle?.length > 0 &&
                      tab === "policy_history" ? (
                        <div className='active' id='policy_history'>
                          <PolicyHistory />
                        </div>
                      ) : null}
                    </div>
                  </div>
                ) : (
                  "Something went wrong!"
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalContainer
        modal_id='pay_premium'
        modal_width='modal-md'
        bradius='rounded-2'
      >
        <PayPremium
          customer_id={customer_policy_details?.policy_app_details?.customerId}
          policy_app_no={
            customer_policy_details?.policy_app_details?.policyAppNumber
          }
          policy_id={customer_policy_details?.policy_app_rsk?.[0]?.policy_id}
        />
      </ModalContainer>
      <PreviewPolicyAppSchedule
        modal_id='policy_schedule'
        // policyID={policyID}
        edit
        data={temp_policy_attach_data}
        policyDetails={customer_policy_details?.policy_app_details}
      />
      <ModalContainer
        modal_id='confirm_renewal'
        modal_width='modal-sm'
        bradius='rounded-2'
      >
        <ConfirmUnderwrite
          handleSubmit={handleRenewal}
          title='Renewal'
          prompt={`Are you sure you want to renew ${customer_policy_details?.policy_app_details?.policyName}?`}
          isTitle
          promptStyle='lh-sm fs-5'
          buttonText='Yes'
        />
      </ModalContainer>

      <button
        ref={confirmRenewal}
        type='button'
        class='btn btn-primary d-none'
        data-bs-toggle='modal'
        data-bs-target='#renewalConfirmation'
      >
        Yes
      </button>

      <Confirmation
        modal_id={"renewalConfirmation"}
        handleSubmit={() =>
          navigate("/admin/policy-application/renewal", {
            state,
          })
        }
      >
        <div className='text-center pt-3'>
          <p>This policy account has an outstanding premium of</p>
          <p className='text-danger fw-bold fs-4'>
            &#8358;
            {customer_policy_details?.reminder &&
              customer_policy_details?.reminder[1]}
          </p>
          <p>Would you like to continue with policy renewal?</p>
        </div>
      </Confirmation>
    </>
  );
};

export default CustomerPolicyView;
